const getFetchHeaders = require("./getFetchHeaders");
const fetchAnonymousContent = require("./fetchAnonymousContent");
const getFetchAgent = require("./getFetchAgent");
const fetchAuthenticatedContent = require("./fetchAuthenticatedContent");

module.exports = async function fetchAs({
	endpoint,
	dispatch,
	headers = null,
	agent = null,
	testing = false,
	extraParams = {},
	method = "GET",
	ssr = false,
	body = null,
}) {
	// console.warn('fetchAs', dispatch);
	
	let response;
	if (dispatch) {
		response = await fetchAuthenticatedContent({
			dispatch,
			endpoint,
			method,
			body,
			headers,
			extraParams,
		});
	} else {
		const { useDefaultJsonApiPath = true, returnResponse = false } = extraParams;
		const jsonapiBase = useDefaultJsonApiPath ? "/jsonapi" : "";
		const url = `${process.env.CLF_BACKEND_URL}${jsonapiBase}/${endpoint}`;
		if (ssr) {
			headers = getFetchHeaders();
			agent = getFetchAgent();
		} else {
			headers = headers || getFetchHeaders();
		}
		let _response = await fetchAnonymousContent(
			url,
			method,
			body,
			headers,
			agent,
			returnResponse
		);
		if (returnResponse) {
			return _response;
		} else {
			if (_response && _response.data) {
				if (
					(Array.isArray(_response.data) && _response.data.length > 0) ||
					(!Array.isArray(_response.data) && _response.data.id) ||
					testing
				) {
					response = _response;
				}
			}
		}
	}
	return response;
};
